import { render, staticRenderFns } from "./fileUploader2.vue?vue&type=template&id=6831ef88"
import script from "./fileUploader2.vue?vue&type=script&lang=js"
export * from "./fileUploader2.vue?vue&type=script&lang=js"
import style0 from "./fileUploader2.vue?vue&type=style&index=0&id=6831ef88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports